import { DateFormatter } from 'infrastructure/functions';
import { DateFormats } from 'infrastructure/enums';
import { type FC } from 'react';

import s from './styles.module.scss';

interface DateCellProps {
  date?: string | Date;
}

const DateCell: FC<DateCellProps> = ({ date }) => {
  return (
    <div className={s.date}>
      {DateFormatter({
        date,
        format: DateFormats['MM-dd-yyyy hh:mm:ss a'],
      })}
    </div>
  );
};
export default DateCell;
